// pages/controleBar/comandas/PesqComandaPage.js
import React, { useEffect, useMemo, useState } from "react";
import { fetchData, postData } from "../../../services/Api";
import { useMessage } from "../../../contexts/geral/MessageContext";
import { formatCurrency } from "../../../utils/numberUtils";
import Input from "../../../components/input/Input";
import Select from "../../../components/input/Select";
import PageContainer from "../../../components/geral/PageContainer";
import PageHeader from "../../../components/geral/PageHeader";
import PageContent from "../../../components/geral/PageContent";
import PageFooter from "../../../components/geral/PageFooter";
import ComandaItensModal from "./ComandaItensModal";

import { StatusComandaOptions, getStatusComandaLabel } from "../../../models/controleBar/comandas/StatusComanda";

// ✅ AQUI
import { usePrinterComanda } from "../../../contexts/geral/PrinterComandaContext";

const HORA_INICIAL_PADRAO = "00:00";
const HORA_FINAL_PADRAO = "23:59";

const montarDataHoraFiltro = (data, hora, segundos = "00", horaPadrao = HORA_INICIAL_PADRAO) => {
  if (!data) return null;

  return `${data}T${hora || horaPadrao}:${segundos}`;
};

const PesqComandaPage = () => {
  const { showMessage } = useMessage();

  // ✅ AQUI
  const { printResumoComandas } = usePrinterComanda();

  const [comandas, setComandas] = useState([]);
  const [selectedComanda, setSelectedComanda] = useState(null);

  // filtros
  const [codigo, setCodigo] = useState("");
  const [mesa, setMesa] = useState("");
  const [status, setStatus] = useState(-1);
  const [dataIni, setDataIni] = useState("");
  const [dataFim, setDataFim] = useState("");
  const [horaIni, setHoraIni] = useState(HORA_INICIAL_PADRAO);
  const [horaFim, setHoraFim] = useState(HORA_FINAL_PADRAO);

  const [showItensModal, setShowItensModal] = useState(false);

  useEffect(() => {
    const hoje = new Date().toISOString().split("T")[0];

    setDataIni(hoje);
    setDataFim(hoje);
    setHoraIni(HORA_INICIAL_PADRAO);
    setHoraFim(HORA_FINAL_PADRAO);

    // ✅ chama já com os valores corretos (não depende do state)
    buscarComandas({
        dataIni: montarDataHoraFiltro(hoje, HORA_INICIAL_PADRAO),
        dataFim: montarDataHoraFiltro(hoje, HORA_FINAL_PADRAO, "59", HORA_FINAL_PADRAO),
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);


  const buscarComandas = async (override = {}) => {
    try {
        let filtros = {
        comandaCodigo: codigo,
        mesaCodigo: mesa,
        status,
        dataIni: montarDataHoraFiltro(dataIni, horaIni),
        dataFim: montarDataHoraFiltro(dataFim, horaFim, "59", HORA_FINAL_PADRAO),
        ...override, // ✅ sobrescreve no primeiro load
        };

        const result = await postData("/Comanda/BuscaComandas", filtros);
        setComandas(result || []);
        setSelectedComanda(null);
    } catch (err) {
        showMessage("Erro ao buscar comandas", "danger");
        setComandas([]);
    }
  };


  const handleVisualizar = async () => {
    if (!selectedComanda) {
      showMessage("Selecione uma comanda", "warning");
      return;
    }

    try {
      const comandaCompleta = await fetchData(`/Comanda/GetById?comandaId=${selectedComanda.id}`);
      setSelectedComanda(comandaCompleta || selectedComanda);
      setShowItensModal(true);
    } catch (err) {
      showMessage("Erro ao carregar itens da comanda", "danger");
    }
  };

  // ✅ TROCAR ESTE MÉTODO
  const handleImprimir = () => {
    if (!selectedComanda) {
      showMessage("Selecione uma comanda para imprimir", "warning");
      return;
    }

    // a rotina do MesaControlePage recebe (mesa, [comandas])
    const mesaSel = selectedComanda.mesa || {
      id: selectedComanda.mesaId,
      codigo: selectedComanda.mesa?.codigo || mesa || "-",
    };

    printResumoComandas(mesaSel, [selectedComanda]);
  };

  const totais = useMemo(() => {
    const total = comandas.reduce((acc, c) => acc + (c.valorTotal || 0), 0);
    const pago = comandas.reduce((acc, c) => acc + (c.valorPago || 0), 0);
    const restante = total - pago;
    return { total, pago, restante, qtd: comandas.length };
  }, [comandas]);

  return (
    <PageContainer>
      <h2 className="page-title">Pesquisa de Comandas</h2>

      <PageHeader>
        <Input label="Comanda" value={codigo} onChange={e => setCodigo(e.target.value)} size={120} />
        <Input label="Mesa" value={mesa} onChange={e => setMesa(e.target.value)} size={100} />

        <Select
          label="Status"
          size={150}
          options={StatusComandaOptions}
          value={status}
          onChange={e => setStatus(parseInt(e.target.value))}
        />

        <Input label="Data Inicial" type="date" value={dataIni} onChange={e => setDataIni(e.target.value)} size={130} />
        <Input label="Hora Inicial" type="time" value={horaIni} onChange={e => setHoraIni(e.target.value)} size={90} />
        <Input label="Data Final" type="date" value={dataFim} onChange={e => setDataFim(e.target.value)} size={130} />
        <Input label="Hora Final" type="time" value={horaFim} onChange={e => setHoraFim(e.target.value)} size={90} />
        <button className="btn btn-search" onClick={() => buscarComandas()}>Buscar</button>
      </PageHeader>

      <PageContent>
        <table className="page-content-table">
          <thead>
            <tr>
              <th></th>
              <th>Comanda</th>
              <th>Mesa</th>
              <th>Cliente</th>
              <th>Abertura</th>
              <th>Status</th>
              <th>Total</th>
              <th>Pago</th>
              <th>Restante</th>
            </tr>
          </thead>
          <tbody>
            {comandas.length ? comandas.map(c => (
              <tr key={c.id}>
                <td>
                  <input
                    type="radio"
                    checked={selectedComanda?.id === c.id}
                    onChange={() => setSelectedComanda(c)}
                  />
                </td>
                <td>{c.codigo}</td>
                <td>{c.mesa?.codigo}</td>
                <td>{c.nomeCliente || "-"}</td>
                <td>{new Date(c.abertura).toLocaleDateString("pt-BR")}</td>
                <td>{getStatusComandaLabel(c.status)}</td>
                <td>{formatCurrency(c.valorTotal)}</td>
                <td>{formatCurrency(c.valorPago)}</td>
                <td>{formatCurrency((c.valorTotal || 0) - (c.valorPago || 0))}</td>
              </tr>
            )) : (
              <tr>
                <td colSpan={9}>Nenhuma comanda encontrada</td>
              </tr>
            )}
          </tbody>
        </table>
      </PageContent>

      <PageFooter>
        <div style={{ width: "100%", display: "flex", alignItems: "center", justifyContent: "space-between" }}>
          <div style={{ display: "flex", gap: 8 }}>
            <button className="btn btn-info btn-footer" onClick={handleVisualizar}>
              Visualizar Comanda
            </button>
            <button className="btn btn-primary btn-footer" onClick={handleImprimir}>
              Imprimir Comanda
            </button>
          </div>

          <div style={{ display: "flex", alignItems: "center", gap: 14, fontWeight: 600 }}>
            <span>Qtd: {totais.qtd}</span>
            <span>Total: {formatCurrency(totais.total)}</span>
            <span>Pago: {formatCurrency(totais.pago)}</span>
            <span>Restante: {formatCurrency(totais.restante)}</span>
          </div>
        </div>
      </PageFooter>

      <ComandaItensModal
        show={showItensModal}
        onHide={() => setShowItensModal(false)}
        comanda={selectedComanda}
      />
    </PageContainer>
  );
};

export default PesqComandaPage;
